<template>
  <div
    class="modal fade"
    id="resellerInfoWModal"
    tabindex="-1"
    aria-labelledby="resellerInfoWModallLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width: 700px;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fw-bold" id="resellerInfoWModallLabel">리셀러 등록하기</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body" style="overflow-y: auto; max-height: 80vh;">
          <div class="modalInputDiv">
            <label>사업자등록번호<span class="text-danger">*</span></label>
            <input
              type="text"
              placeholder="사업자등록번호를 입력해주세요"
              v-model="businessNumber"
              maxlength="12"
              @input="changeBusinessNumber"
              @keyup.enter="businessNumberValidate"
            />
            <div class="modalInputRight">
              <button
                type="button"
                class="btn btn-primary modalBtnRight"
                @click="businessNumberValidate()"
              >
                중복확인
              </button>
            </div>
          </div>
          <div class="modalInputDiv">
            <label></label>
            <span class="businessNumberMsgW"></span>
          </div>
          <div class="modalInputDiv">
            <label>사업자등록증</label>
            <input
              type="text"
              :value="businessFileName"
              readonly
            />
            <input
              type="file"
              id="businessFileInputW"
              ref="businessFileInputW"
              @change="changeBusinessNumImage()"
              style="display: none"
              accept=".png, .jpg, .jpeg, .pdf"
            />
            <div class="modalInputRight">
              <button
                type="button"
                class="btn btn-outline-dark modalBtnRight"
                @click="openBusinessFileInput()"
              >
                <i class="material-icons" style="vertical-align: middle">attach_file</i>
              </button>
              <button
                type="button"
                class="btn btn-outline-danger modalBtnRight"
                v-if="businessFileName"
                @click="deleteBusinessNumImage()"
              >
                <i class="material-icons" style="vertical-align: middle">delete</i>
              </button>
            </div>
          </div>
          <div class="modalInputDiv">
            <label>테스트 여부</label>
            <a-checkbox v-model:checked="isTestCompany">테스트 리셀러로 등록</a-checkbox>
          </div>
          <div class="modalInputDiv">
            <label>리셀러명<span class="text-danger">*</span></label>
            <input
              type="text"
              placeholder="리셀러명을 입력해주세요"
              v-model="resellerName"
            />
          </div>
          <div class="modalInputDiv">
            <label>대표자명</label>
            <input
              type="text"
              placeholder="대표자명을 입력해주세요"
              v-model="resellerCeoName"
            />
          </div>
          <div class="modalInputDiv">
            <label>대표 전화번호</label>
            <input
              type="text"
              placeholder="대표 전화번호를 입력해주세요"
              v-model="resellerPhoneNumber"
              maxlength="13"
              @input="changeResellerPhoneNumber"
            />
          </div>
          <div class="modalInputDiv">
            <label>페이지 로고</label>
            <input
              type="text"
              :value="logoFileName"
              readonly
            />
            <input
              type="file"
              id="logoFileInputW"
              ref="logoFileInputW"
              @change="changeLogoImage()"
              style="display: none"
              accept="image/png, image/jpeg, image/jpg"
            />
            <div class="modalInputRight">
              <button
                type="button"
                class="btn btn-outline-dark modalBtnRight"
                @click="openLogoFileInput()"
              >
                <i class="material-icons" style="vertical-align: middle">attach_file</i>
              </button>
              <button
                type="button"
                class="btn btn-outline-danger modalBtnRight"
                v-if="logoFileName"
                @click="deleteLogoImage()"
              >
                <i class="material-icons" style="vertical-align: middle">delete</i>
              </button>
            </div>
          </div>
          <div class="modalInputDiv" v-if="logoPreviewUrl">
            <label></label>
            <img id="logoPrevW" class="imgPrev" :src="logoPreviewUrl" alt="" />
          </div>
          <div class="modalInputDiv">
            <label></label>
            <span class="modalTextSmall">
              이미지 권장 사이즈는 300*60입니다. 파일 크기는 최대 100MB까지 등록 가능합니다.
            </span>
          </div>

          <hr style="margin: 1.5rem 0;" />

          <div class="modalInputDiv">
            <label>관리자 이름<span v-if="managerId" class="text-danger">*</span></label>
            <input
              type="text"
              placeholder="관리자 이름을 입력해주세요"
              v-model="managerName"
            />
          </div>
          <div class="modalInputDiv">
            <label>관리자 직급</label>
            <input
              type="text"
              placeholder="관리자 직급을 입력해주세요"
              v-model="managerDuty"
            />
          </div>
          <div class="modalInputDiv">
            <label>관리자 연락처</label>
            <input
              type="text"
              placeholder="관리자 연락처를 입력해주세요"
              v-model="managerPhoneNumber"
              maxlength="13"
              @input="changeManagerPhoneNumber"
            />
          </div>

          <hr style="margin: 1.5rem 0;" />

          <!-- 관리자 계정 섹션 (수정 모달의 "관리자 계정 변경" 박스와 동일한 스타일) -->
          <div class="account-section">
            <h6 style="margin-bottom: 16px; font-weight: 600;">관리자 계정</h6>
            <!-- 브라우저 자동완성 방지용 숨김 입력 -->
            <input
              type="text"
              placeholder="관리자의 아이디를 입력해주세요."
              style="display: none!important;"
            />
            <input
              type="password"
              placeholder="비밀번호를 입력해주세요."
              @input="passwordOnChange"
              style="display: none!important;"
            />
            <div class="modalInputDiv">
              <label>관리자 아이디</label>
              <input
                type="text"
                placeholder="관리자 아이디를 입력해주세요"
                v-model="managerId"
                @keyup.enter="managerIdValidate"
                @input="changeManagerId"
              />
              <div class="modalInputRight">
                <button
                  type="button"
                  class="btn btn-primary modalBtnRight"
                  @click="managerIdValidate()"
                >
                  중복확인
                </button>
              </div>
            </div>
            <div class="modalInputDiv">
              <label></label>
              <span class="managerIdMsgW"></span>
            </div>
            <div class="modalInputDiv">
              <label>비밀번호</label>
              <input
                type="password"
                placeholder="비밀번호를 입력해주세요"
                v-model="password"
                @input="passwordOnChange"
              />
            </div>
            <div class="modalInputDiv">
              <label>비밀번호 확인</label>
              <input
                type="password"
                placeholder="비밀번호를 다시 입력해주세요"
                v-model="passwordConfirm"
                @input="passwordOnChange"
              />
            </div>
            <div class="modalInputDiv">
              <label></label>
              <span class="passwordMsgW"></span>
            </div>
          </div>
        </div>
        <div class="modal-footer" style="justify-content: center">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            style="color: #666666; background: #fff; border: 1px solid #666;"
          >
            취소
          </button>
          <button
            type="button"
            class="btn btn-info"
            @click="addReseller()"
            :disabled="isSubmitting"
          >
            등록하기
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { openDialog, changeBytesToKilos, businessNumberFormatter, phoneNumberFormatter } from "@/utils/utils";
import {
  YnEnum
} from '@/enums/common.enums'

export default {
  emits: ['reload'],
  data() {
    return {
      type: "RESELLER",
      resellerId: "",

      resellerName: "",
      resellerCeoName: "",
      resellerPhoneNumber: "",
      businessNumber: "",

      managerName: "",
      managerDuty: "",
      managerPhoneNumber: "",
      managerId: "",
      password: "",
      passwordConfirm: "",

      businessFileName: "",
      businessFileData: null,

      logoFileName: "",
      logoFileData: null,
      logoPreviewUrl: "",

      isTestCompany: false,

      isBusinessNumberValid: false,
      isPasswordValid: false,
      isManagerIdValid: false,
      isSubmitting: false,
    };
  },

  async mounted() {
    this.initValues();
  },
  methods: {
    changeResellerPhoneNumber() {
      this.resellerPhoneNumber = phoneNumberFormatter(this.resellerPhoneNumber.toString());
    },
    changeManagerPhoneNumber() {
      this.managerPhoneNumber = phoneNumberFormatter(this.managerPhoneNumber.toString());
    },
    changeBusinessNumber() {
      this.businessNumber = businessNumberFormatter(this.businessNumber);
      this.isBusinessNumberValid = false;
      if(document.querySelector(".businessNumberMsgW")) document.querySelector(".businessNumberMsgW").textContent = "";
    },
    changeManagerId() {
      this.isManagerIdValid = false;
      if(document.querySelector(".managerIdMsgW")) document.querySelector(".managerIdMsgW").textContent = "";
    },
    // 리셀러 등록
    async addReseller() {
      if(this.isSubmitting) return;
      this.isSubmitting = true;
      try {
        await this.submitAdd();
      } finally {
        this.isSubmitting = false;
      }
    },
    async submitAdd() {
      if(await this.validateData()) {
        try {
          const obj = {};

          obj.name = this.resellerName;
          if(this.resellerCeoName) obj.ceo = this.resellerCeoName;
          obj.cNo = this.businessNumber.replace(/-/g, '');
          obj.isTestCompany = this.isTestCompany ? YnEnum.Y : YnEnum.N;
          obj.medicalDept = []; // 리셀러는 진료과목 없음 (백엔드 필수값)

          if(this.businessFileData) {
            const businessImgUrl = await this.uploadImageOnObjectStorage(this.businessFileData);
            obj.cNoUrl = businessImgUrl;
          } else {
            obj.cNoUrl = '';
          }
          if(this.logoFileData) {
            const logoImgUrl = await this.uploadImageOnObjectStorage(this.logoFileData);
            obj.imgUrl = logoImgUrl;
          } else {
            obj.imgUrl = '';
          }

          if(this.resellerPhoneNumber) {
            obj.call = this.resellerPhoneNumber.replace(/-/g, '');
          } else {
            obj.call = '';
          }
          obj.type = this.type;

          // accountInfo는 항상 전달 (백엔드에서 username 유무로 계정 생성 여부 판단)
          const accountInfo = {};
          if(this.managerId) {
            accountInfo.username = this.managerId.trim();
            accountInfo.password = this.password;
          }
          accountInfo.role = this.type;
          if(this.managerName) accountInfo.name = this.managerName;
          if(this.managerDuty) accountInfo.duty = this.managerDuty;
          if(this.managerPhoneNumber) accountInfo.mobile = this.managerPhoneNumber.replace(/-/g, "");
          obj.accountInfo = accountInfo;

          const response = await this.$apiInstance.post(`/companies`, obj);
          if(response.status === 200 || response.status === 201) {
            await openDialog("리셀러 등록이 완료되었습니다.", "success", "확인")
              .then(() => {
                location.reload();
              });
          } else {
            await openDialog("리셀러 등록에 실패하였습니다.", "error", "확인");
          }

        } catch (error) {
          console.log(error);
          if(error.response && error.response.status === 400) {
            await openDialog("이미 존재하는 계정입니다.", "error", "확인");
          } else {
            await openDialog("리셀러 등록에 실패하였습니다.", "error", "확인");
          }
        }
      }
    },

    // 이미지 오브젝트스토리지에 업로드
    async uploadImageOnObjectStorage(fileData) {
      const response = await this.$apiInstance.post(`/object-storages`, fileData);
      if(response.status === 200 || response.status === 201) {
        return response.data.url;
      } else {
        return "";
      }
    },

    // 사업자등록번호 validate
    async businessNumberValidate() {
      const businessNumberMsg = document.querySelector(".businessNumberMsgW");
      if (this.businessNumber.replaceAll('-','').length < 10) {
          businessNumberMsg.setAttribute("class", "businessNumberMsgW fail");
          businessNumberMsg.textContent = "잘못된 사업자등록번호입니다.";
          this.isBusinessNumberValid = false;
      } else {
        try {
          const response = await this.$apiInstance.get(`/companies/duplicateCheck/cNo/${this.businessNumber}`);
          if(response && (response.status === 200 || response.status === 201) && !response.data) {
            businessNumberMsg.setAttribute("class", "businessNumberMsgW success");
            businessNumberMsg.textContent = "사용할 수 있는 사업자등록번호입니다.";
            this.isBusinessNumberValid = true;
          } else {
            businessNumberMsg.setAttribute("class", "businessNumberMsgW fail");
            businessNumberMsg.textContent = "이미 존재하는 사업자등록번호입니다.";
            this.isBusinessNumberValid = false;
          }
        } catch (error) {
          console.log(error);
          businessNumberMsg.setAttribute("class", "businessNumberMsgW fail");
          businessNumberMsg.textContent = "중복 확인 중 오류가 발생했습니다.";
          this.isBusinessNumberValid = false;
        }
      }
    },
    async managerIdValidate (){
      const managerIdMsgW = document.querySelector('.managerIdMsgW');
      if(!this.managerId) {
        managerIdMsgW.setAttribute("class", "managerIdMsgW fail");
        managerIdMsgW.textContent = "관리자 아이디를 입력해주세요.";
        this.isManagerIdValid = false;
        return;
      }
      try {
        const response = await this.$apiInstance.get(`/accounts/duplicateCheck/${encodeURIComponent(this.managerId.trim())}`);
        if(response && (response.status === 200 || response.status === 201) && !response.data) {
          managerIdMsgW.setAttribute("class", "managerIdMsgW success");
          managerIdMsgW.textContent = "사용할 수 있는 아이디입니다.";
          this.isManagerIdValid = true;
        } else {
          managerIdMsgW.setAttribute("class", "managerIdMsgW fail");
          managerIdMsgW.textContent = "이미 존재하는 아이디입니다.";
          this.isManagerIdValid = false;
        }
      } catch (error) {
        console.log(error);
        managerIdMsgW.setAttribute("class", "managerIdMsgW fail");
        const reason = error && error.response && error.response.data && error.response.data.message;
        managerIdMsgW.textContent = (Array.isArray(reason) ? reason.join(", ") : reason) || "중복 확인 중 오류가 발생했습니다.";
        this.isManagerIdValid = false;
      }
    },

    // 비밀번호 변경 시 메시지 분기처리
    passwordOnChange() {
      this.passwordValidate();
    },

    // 비밀번호 validate
    passwordValidate() {
      const passwordMsg = document.querySelector(".passwordMsgW");
      if(this.password.length < 8) {
        this.isPasswordValid = false;
        passwordMsg.setAttribute("class", "passwordMsgW fail");
        passwordMsg.textContent = "비밀번호는 8자리 이상이어야 합니다.";
      } else if(this.password !== this.passwordConfirm) {
        this.isPasswordValid = false;
        passwordMsg.setAttribute("class", "passwordMsgW fail");
        passwordMsg.textContent = "비밀번호가 일치하지 않습니다.";
      } else {
        this.isPasswordValid = true;
        passwordMsg.setAttribute("class", "passwordMsgW success");
        passwordMsg.textContent = "사용 가능한 비밀번호입니다.";
      }
    },

    // 전체 데이터 검증
    async validateData() {
      // 사업자등록번호 검증
      if (!this.isBusinessNumberValid) {
        await openDialog("사업자등록번호를 확인해주세요.", "error", "확인");
        return false;
      }
      // 리셀러명 검증
      if (!this.resellerName) {
        await openDialog("리셀러명을 입력해주세요.", "error", "확인");
        return false;
      }
      // 관리자 아이디 검증 (입력된 경우에만)
      if (this.managerId && !this.isManagerIdValid) {
        await openDialog("관리자 아이디 중복확인을 해주세요.", "error", "확인");
        return false;
      }
      // 관리자 이름 검증 (계정이 생성되는 경우, 즉 관리자 아이디가 입력된 경우에만)
      if (this.managerId && !this.managerName) {
        await openDialog("관리자 이름을 입력해 주세요.", "error", "확인");
        return false;
      }
      // 비밀번호 검증 (관리자 아이디가 입력된 경우에만)
      if (this.managerId && this.password && !this.passwordConfirm) {
        await openDialog("비밀번호 확인을 입력해주세요.", "error", "확인");
        return false;
      }
      if (this.managerId && this.password && this.password !== this.passwordConfirm) {
        await openDialog("비밀번호가 일치하지 않습니다.", "error", "확인");
        return false;
      }
      return true;
    },

    // 값 초기화
    initValues() {
      this.resellerName = "";
      this.resellerCeoName = "";
      this.resellerPhoneNumber = "";
      this.businessNumber = "";
      this.managerName = "";
      this.managerDuty = "";
      this.managerPhoneNumber = "";
      this.managerId = "";
      this.password = "";
      this.passwordConfirm = "";
      this.businessFileName = "";
      this.businessFileData = null;
      this.logoFileName = "";
      this.logoFileData = null;
      this.logoPreviewUrl = "";
      this.isTestCompany = false;
      this.isBusinessNumberValid = false;
      this.isPasswordValid = false;
      this.isManagerIdValid = false;
    },

    // 파일 관련 메서드
    openBusinessFileInput() {
      if(this.$refs.businessFileInputW) this.$refs.businessFileInputW.click();
    },
    async changeBusinessNumImage() {
      const file = this.$refs.businessFileInputW.files[0];
      if (!this.validateFileUpload(file)) return;
      this.businessFileName = file.name;
      this.businessFileData = new FormData();
      this.businessFileData.append('file', file);
    },
    deleteBusinessNumImage() {
      this.businessFileName = "";
      this.businessFileData = null;
      this.$refs.businessFileInputW.value = "";
    },
    openLogoFileInput() {
      if(this.$refs.logoFileInputW) this.$refs.logoFileInputW.click();
    },
    async changeLogoImage() {
      const file = this.$refs.logoFileInputW.files[0];
      if (!this.validateFileUpload(file)) return;
      this.logoFileName = file.name;
      this.logoFileData = new FormData();
      this.logoFileData.append('file', file);
      const reader = new FileReader();
      reader.onload = (e) => {
        this.logoPreviewUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    deleteLogoImage() {
      this.logoFileName = "";
      this.logoFileData = null;
      this.logoPreviewUrl = "";
      this.$refs.logoFileInputW.value = "";
    },
    validateFileUpload(file) {
      if (!file) return false;
      if (changeBytesToKilos(file.size) > 100) {
        openDialog("파일 크기가 100MB를 초과합니다.", "error", "확인");
        return false;
      }
      return true;
    },
  },
};
</script>
<style scoped>
.modalInputDiv {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.modalInputDiv label {
  width: 30%;
  font-weight: 500;
}

.modalInputDiv input[type="text"],
.modalInputDiv input[type="password"] {
  width: 50%;
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 0.5rem;
  height: 35px;
}

.modalInputRight {
  display: flex;
  margin-left: 10px;
}

.modalBtnRight {
  margin-bottom: 0 !important;
  margin-right: 5px;
}

.imgPrev {
  max-width: 200px;
  max-height: 100px;
}

.modalTextSmall {
  font-size: 12px;
  color: #999;
}

.text-danger {
  color: #dc3545;
}

.account-section {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 8px;
  margin-top: 0.5rem;
}

.businessNumberMsgW,
.managerIdMsgW,
.passwordMsgW {
  font-size: 12px;
}

.businessNumberMsgW.success,
.managerIdMsgW.success,
.passwordMsgW.success {
  color: #28a745;
}

.businessNumberMsgW.fail,
.managerIdMsgW.fail,
.passwordMsgW.fail {
  color: #dc3545;
}
</style>
